import React from 'react';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { Select, Popover, Input } from 'antd';

/**
 * @description: port select render
 * @param {{
 * id: string,
 * pairInfo: {libraryId, modelKey, node}
 * portList: Array<{ name: string, disabled: boolean }>,
 * portValue: string,
 * displayPin: string,
 * closePortPopover: () => void,
 * selectNode: (nodeName: string) => void,
 * visible: boolean,
 * nodeClassName: string,
 * fileValue: string,
 * fileList: Array<{ name: string, disabled: boolean }>,
 * selectFile: (fileValue: string) => void,
 * }} props
 */
class PortSelectRender extends React.Component {
  constructor() {
    super();
    this.state = {
      searchValue: ""
    };
  }

  clearNode = (e) => {
    e.stopPropagation();
    this.props.selectNode('');
  }

  searchNode = (e) => {
    this.setState({
      searchValue: e.target.value
    })
  }

  nodeSelectRender = () => {
    const { searchValue } = this.state;
    const { pairInfo, portList = [], portValue, displayPin, fileValue = {}, fileList = [] } = this.props;
    // Determine whether the port is from the currently selected file
    const isConsist = pairInfo.libraryId === fileValue.libraryId && pairInfo.modelKey === fileValue.modelKey
    const nodeListFilter = portList.filter(item => !searchValue || item.label.includes(searchValue));
    return (
      <div className='nodes-content' onClick={(e) => e.stopPropagation()}>
        <div className='nodes-content-header'>
          <span className='nodes-content-header-span'>Component Pin {displayPin}</span>
        </div>
        <div className='node-content-close' onClick={this.props.closePortPopover}>
          <CloseOutlined className='node-content-close-icon' />
        </div>
        <div className="node-list-body-with-search">
          <div className="node-list-body-search-wrapper">
            <Select
              placeholder="Select File"
              className='nodes-list-file-select'
              classNames={{ popup: { root: 'nodes-list-file-dropdown' } }}
              popupMatchSelectWidth={false}
              labelInValue
              value={{
                key: fileValue.libraryId ? fileValue.subckt ? `${fileValue.libraryId}::${fileValue.modelKey}::${fileValue.subckt}` : `${fileValue.libraryId}::${fileValue.modelKey}` : "",
                label: fileValue.subckt ? `${fileValue.fileName}::${fileValue.subckt}` : fileValue.fileName || ""
              }}
              options={fileList}
              onChange={option => option && this.props.selectFile(option.label, option.value)}
            />
            <Input
              placeholder="Search Port"
              allowClear
              suffix={!searchValue ? <SearchOutlined style={{ color: 'rgba(0, 0, 0, .25)' }} /> : undefined}
              value={searchValue ? searchValue : isConsist ? portValue : ""}
              onChange={(e) => this.searchNode(e)}
            />
            <ul className='node-list-ul'>
              {nodeListFilter.map(item =>
                <li
                  key={item.value}
                  title={item.label}
                  className={portValue === item.value && isConsist ? 'current-pin-selected-node-li' : (item.disabled ? 'node-li-selected' : '')}
                  onClick={!item.disabled ? () => this.props.selectNode(item.value) : null}
                >
                  {item.label}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { visible, id, children } = this.props;
    return (
      <Popover
        content={this.nodeSelectRender()}
        trigger="click"
        open={visible}
        classNames={{ root: 'spice-node-select-Popover' }}
        id={id}
        destroyOnHidden={true}
      >
        {children}
      </Popover>
    );
  }
}

export default PortSelectRender;